import { HashLink } from "react-router-hash-link";
import Brochure from "../assets/images/brochure.pdf";

export default function Copyright({ showModal, ...other }) {
    const date = new Date().getFullYear();
    return (
        <div {...other}>
            <div className="extra-links">
                <p className="accessibility" onClick={showModal}>
                    Accessibility
                </p>{" "}
                |
                <p className="fair-housing" onClick={showModal}>
                    Fair Housing Notice
                </p>
                <p className="terms" onClick={showModal}>
                    Terms
                </p>{" "}
                |
                <a className="brochure" target="_blank" rel="noopener noreferrer" href={Brochure}>
                    Brochure
                </a>
            </div>
            <p> Copyright © {date} EXR, All rights reserved.</p>
            <HashLink style={{ color : 'white', marginTop: '10px'}} className="contact" smooth to="/contact#form">
                *Restrictions apply, Contact for Details
            </HashLink>
        </div>
    )
}